import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { NgApexchartsModule } from "ng-apexcharts";
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@ngneat/transloco';
import { UserService } from '../../../core/user/user.service';
import { AccountDetails } from '../../../core/user/user.types';
import { DecimalPipe, NgIf, NgFor, NgOptimizedImage } from '@angular/common';
import { environment } from "../../../../environments/environment";
import { RestFactoryService } from "../../../core/services/rest-factory.service";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
    selector: "project",
    templateUrl: "./project.component.html",
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoModule, MatIconModule, MatButtonModule, MatRippleModule, MatMenuModule, MatTabsModule, MatButtonToggleModule, NgApexchartsModule, NgIf, NgFor, MatTableModule, NgOptimizedImage, MatProgressSpinnerModule, DecimalPipe],
})
export class ProjectComponent implements OnInit, OnDestroy {
    userUiType: number;
    user: AccountDetails;
    ambassadorMetrics: any;
    isLoadingMetrics: boolean = false;
    showMetrics: boolean = false;
    myProperties: any[] = [];
    isInitializing: boolean = true;
    ambassadorDestinationId: string | null = null;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _userService: UserService,
        private _restFactoryService: RestFactoryService,
        private _router: Router
    ) {
    }

    ngOnInit(): void {
        this.userUiType = environment.user_ui_type;
        this.user = this._userService.getAccountDetails();

        if (this.userUiType === 2 || this.userUiType === 4) {
            this._fetchMenuDataWithRetry(0, 3);
        } else {
            this.isInitializing = false;
        }

        this._changeDetectorRef.markForCheck();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    private _fetchMenuDataWithRetry(attempt: number, maxRetries: number): void {
        let success = false;
        const menuDataString = localStorage.getItem('MENU_DATA');

        if (menuDataString) {
            try {
                const menuData = JSON.parse(menuDataString);
                success = this._processMenuData(menuData);
            } catch (error) {
            }
        }

        if (success) {
            this.isInitializing = false;
            this._changeDetectorRef.markForCheck();
        } else if (attempt < maxRetries) {
            setTimeout(() => {
                this._fetchMenuDataWithRetry(attempt + 1, maxRetries);
            }, 2000);
        } else {
            this.isInitializing = false;
            this._changeDetectorRef.markForCheck();
        }
    }

    private _processMenuData(menuData: any): boolean {
        if (this.userUiType === 2) {
            const contentGroup = menuData.find((group: any) => group.id === 'content');
            if (contentGroup && contentGroup.children && contentGroup.children.length > 0) {
                this.myProperties = contentGroup.children;
                return true;
            }
        } else if (this.userUiType === 4) {
            let foundId = null;
            for (const group of menuData) {
                if (group.children) {
                    for (const item of group.children) {
                        if (item.queryParams && item.queryParams.id_destination) {
                            foundId = item.queryParams.id_destination;
                            break;
                        }
                    }
                }
                if (foundId) break;
            }

            if (foundId) {
                this.ambassadorDestinationId = foundId;
                this._getAmbassadorMetrics(foundId);
                return true;
            }
        }
        return false;
    }

    private _getAmbassadorMetrics(destinationId: string): void {
        this.isLoadingMetrics = true;

        const payload = new FormData();
        payload.append('id_destination', destinationId);

        this._restFactoryService.httpPostService('/admin/dashboard/metrics/ambassador', payload)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                this.ambassadorMetrics = response;
                this.isLoadingMetrics = false;
                this._changeDetectorRef.markForCheck();
            });
    }

    navigateToManagement(qaction: string, explicitDestId?: string): void {
        const destinationId = explicitDestId || this.ambassadorDestinationId;

        if (destinationId) {
            this._router.navigate(['/content/destinations/management'], {
                queryParams: {
                    id_destination: destinationId,
                    qaction: qaction
                }
            });
        }
    }
}
